module.exports = __webpack_public_path__ + "2f5a0fb8e1a7e6cdd70d9797ddefddd3.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/backgrounds/rain.png
// module id = 2756
// module chunks = 0